import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NewsletterSection from '../components/NewsletterSection';
import '../styles/Blog.css';
import blogPosts from '../data/blogPosts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import ScrollDownArrow from '../components/ScrollDownArrow';

const POSTS_PER_PAGE = 6;

export default function Blog() {
  const [page, setPage] = useState(1);
  const [copiedIdx, setCopiedIdx] = useState(null);
  const totalPages = Math.ceil(blogPosts.length / POSTS_PER_PAGE);
  const paginatedPosts = blogPosts.slice((page - 1) * POSTS_PER_PAGE, page * POSTS_PER_PAGE);

  const handleCopyLink = (slug, idx) => {
    const url = `${window.location.origin}/blog/${slug}`;
    navigator.clipboard.writeText(url);
    setCopiedIdx(idx);
    setTimeout(() => setCopiedIdx(null), 1000);
  };

  return (
    <div className="blog-page">
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="blog-hero-overlay"></div>
        <div className="blog-hero-content">
          <h1 className="blog-hero-title">BLOG</h1>
          <p className="blog-hero-subtitle">We keep you posted on our development</p>
        </div>
        <ScrollDownArrow targetSelector=".blog-grid-section" />
      </section>

      {/* Blog Grid */}
      <section className="blog-grid-section">
        <div className="blog-grid">
          {paginatedPosts.map((post, idx) => (
            <div
              className="blog-card fadeInUp"
              key={post.slug}
              style={{ animationDelay: `${0.1 * idx}s` }}
            >
              <div className="blog-card-image">
                <img src={post.image} alt={post.title} />
                <span className="blog-category">{post.category}</span>
              </div>
              <div className="blog-card-content">
                <div className="blog-meta">
                  <span>{post.date}</span>
                </div>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <div className="blog-card-footer">
                  <Link to={`/blog/${post.slug}`} className="read-more">Read More &rarr;</Link>
                  <button
                    className="blog-copy-link-btn"
                    onClick={() => handleCopyLink(post.slug, idx)}
                  >
                    <FontAwesomeIcon icon={faCopy} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Pagination */}
        <div className="blog-pagination">
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              className={`blog-page-btn${page === i + 1 ? ' active' : ''}`}
              onClick={() => setPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </section>

      <NewsletterSection />
    </div>
  );
} 